exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".participantes-products[data-v-2dd1a164] {\n  background-color: #fafafa;\n  padding: 0 16px;\n  width: 100%;\n}\n.participantes-products .product-header[data-v-2dd1a164] {\n  color: #1e7a75;\n  font-weight: 600;\n  text-align: left;\n}\n.participantes-products .product-details[data-v-2dd1a164] {\n  height: auto;\n  padding: 8px 24px;\n}\n", ""]);

// exports
